import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { ThemePopup } from '../../typings/common';
import { HeaderInfoBlockNewsData } from '../../typings/header';
import { Balloon } from '../Balloon/Balloon';
import { PopupDecorator } from '../PopupDecorator/PopupDecorator';
import { Shape2, Shape2Icon, Shape2Theme } from '../Shape2/Shape2';

import './HeaderInfoBlock.css';
import * as keyset from './HeaderInfoBlock.i18n';
import { NewsExpandedInfoBlock } from './NewsExpandedInfoBlock/NewsExpandedInfoBlock';

const i18n = i18nFactory(keyset);

export interface HeaderInfoBlockProps {
    cls?: string;
    fetchNextInfoBlockNewsItem: () => void;
    isInfoBlockLoading?: boolean;
    hasNewItems?: boolean;
    news: HeaderInfoBlockNewsData;
}

export interface HeaderInfoBlockState {
    isPopupVisible: boolean;
}

export class HeaderInfoBlock extends React.Component<HeaderInfoBlockProps, HeaderInfoBlockState> {
    constructor(props: HeaderInfoBlockProps) {
        super(props);

        this.state = {
            isPopupVisible: false
        };
    }

    render() {
        const { cls, hasNewItems } = this.props;
        const { isPopupVisible } = this.state;

        return (
            <div className={classNames(cls, Bem.cls('header-info-block'))}>
                <Shape2
                    width={24}
                    height={24}
                    cls={Bem.cls('header-info-block', 'bell-icon', {
                        opened: isPopupVisible
                    })}
                    icon={Shape2Icon.bellShape}
                    theme={isPopupVisible ? Shape2Theme.default : Shape2Theme.light}
                    hoverable={true}
                    onClick={this.switchPopupState}
                />
                <Balloon cls={Bem.cls('header-info-block', 'balloon')} visible={Boolean(hasNewItems)} />
                {this.getPopupContent()}
            </div>
        );
    }

    private getPopupContent = () => {
        const {
            fetchNextInfoBlockNewsItem,
            isInfoBlockLoading,
            news: { items, error }
        } = this.props;

        return (
            <PopupDecorator
                visible={this.state.isPopupVisible}
                target={'anchor'}
                anchor={this}
                hasTail={true}
                directions={['bottom-center']}
                theme={ThemePopup.CLEAR}
                onOutsideClick={this.closePopup}
            >
                <div className={Bem.cls('header-info-block', 'popup-content')}>
                    <div className={Bem.cls('header-info-block', 'popup-header')}>{i18n('notifications')}</div>
                    <div className={Bem.cls('header-info-block', 'popup-body')}>
                        <NewsExpandedInfoBlock
                            fetchItems={fetchNextInfoBlockNewsItem}
                            isLoading={isInfoBlockLoading}
                            items={items}
                            error={error}
                        />
                    </div>
                </div>
            </PopupDecorator>
        );
    };

    private switchPopupState = () => this.setState({ isPopupVisible: !this.state.isPopupVisible });

    private closePopup = () => this.setState({ isPopupVisible: false });
}
